function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoOverlay = require('../saito-overlay/saito-overlay');
var DEFAULT_OWN_DESCRIPTION_PLACEHOLDER = 'This is your profile. Stay anonymous or provide an image or comment introducing yourself.';
var DEFAULT_OTHER_DESCRIPTION_PLACEHOLDER = 'No profile description yet.';

/**
 * Modern shared profile card.
 *
 * Display data (always available, no Profile module required):
 *   - publicKey
 *   - host overrides: name, description, banner, avatar, mask_key, icon
 *   - keychain: identicon, returnUsername
 *
 * Profile module (optional enhancement via returnModule('Profile')):
 *   - fetch / live DOM updates
 *   - banner + description editing
 */
var SaitoProfile = /*#__PURE__*/function () {
  function SaitoProfile(app, mod) {
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    _classCallCheck(this, SaitoProfile);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.publicKey = null;
    this.ordinal = 0;
    this.menu = {};
    this.active_tab = '';
    this.tab_container = null;
    this._dom_listener_bound = false;

    // Host overrides (optional)
    // this.name, this.description, this.banner, this.avatar, this.mask_key, this.icon
    // this.editable — set false for read-only; omit/true to use Profile + mod.enable_profile_edits
  }
  return _createClass(SaitoProfile, [{
    key: "hasProfileModule",
    value: function hasProfileModule() {
      var _this$app$modules, _this$app$modules$ret;
      return Boolean((_this$app$modules = this.app.modules) === null || _this$app$modules === void 0 || (_this$app$modules$ret = _this$app$modules.returnModule) === null || _this$app$modules$ret === void 0 ? void 0 : _this$app$modules$ret.call(_this$app$modules, 'Profile'));
    }
  }, {
    key: "hasDescription",
    value: function hasDescription(value) {
      return String(value !== null && value !== void 0 ? value : '').trim().length > 0;
    }
  }, {
    key: "escapeAttr",
    value: function escapeAttr(value) {
      var _this$app$browser;
      if ((_this$app$browser = this.app.browser) !== null && _this$app$browser !== void 0 && _this$app$browser.escapeHTML) {
        return this.app.browser.escapeHTML(String(value !== null && value !== void 0 ? value : ''));
      }
      return String(value !== null && value !== void 0 ? value : '').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }
  }, {
    key: "escapeText",
    value: function escapeText(value) {
      return String(value !== null && value !== void 0 ? value : '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }
  }, {
    key: "classSafe",
    value: function classSafe(value) {
      return String(value !== null && value !== void 0 ? value : '').replace(/[^A-Za-z0-9_-]/g, '');
    }
  }, {
    key: "safeImgSrc",
    value: function safeImgSrc(url, fallback) {
      var _this$app$browser2, _this$app$browser2$is;
      var trimmed = String(url || '').trim();
      if ((_this$app$browser2 = this.app.browser) !== null && _this$app$browser2 !== void 0 && (_this$app$browser2$is = _this$app$browser2.isSafeMediaUrl) !== null && _this$app$browser2$is !== void 0 && _this$app$browser2$is.call(_this$app$browser2, trimmed)) {
        return trimmed;
      }
      if (/^data:image\/svg\+xml[;,]/i.test(trimmed) && !/[\s<>]/.test(trimmed)) {
        return trimmed;
      }
      return fallback;
    }
  }, {
    key: "safeBannerUrl",
    value: function safeBannerUrl(url) {
      var _this$app$browser3, _this$app$browser3$is;
      var trimmed = String(url || '').trim();
      return (_this$app$browser3 = this.app.browser) !== null && _this$app$browser3 !== void 0 && (_this$app$browser3$is = _this$app$browser3.isSafeMediaUrl) !== null && _this$app$browser3$is !== void 0 && _this$app$browser3$is.call(_this$app$browser3, trimmed) ? trimmed : '';
    }

    /**
     * Resolve what the card should show from publicKey + host + keychain only.
     * Profile module never required here.
     */
  }, {
    key: "buildDisplayData",
    value: function buildDisplayData() {
      var _this$app$keychain, _this$app$keychain$re, _this$app$keychain2;
      var publicKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var key = String(publicKey || this.publicKey || '').trim();
      var identicon = key && ((_this$app$keychain = this.app.keychain) === null || _this$app$keychain === void 0 || (_this$app$keychain$re = _this$app$keychain.returnIdenticon) === null || _this$app$keychain$re === void 0 ? void 0 : _this$app$keychain$re.call(_this$app$keychain, key)) || '/saito/img/dreamscape.png';
      var name = 'Anonymous';
      if (typeof this.name === 'string' && this.name.trim()) {
        name = this.name.trim();
      } else if (key && (_this$app$keychain2 = this.app.keychain) !== null && _this$app$keychain2 !== void 0 && _this$app$keychain2.returnUsername) {
        name = this.app.keychain.returnUsername(key) || "Anon-".concat(key.slice(0, 6));
      } else if (key) {
        name = "Anon-".concat(key.slice(0, 6));
      }
      var avatar = typeof this.avatar === 'string' && this.avatar.trim() || identicon;
      var banner = typeof this.banner === 'string' ? this.banner : '';
      var description = typeof this.description === 'string' ? this.description : undefined;
      return {
        publicKey: key,
        name: name,
        avatar: avatar,
        banner: banner,
        description: description,
        mask_key: Boolean(this.mask_key),
        icon: this.icon || '',
        can_edit: this.canEdit(key),
        can_edit_help: this.canEditHelp(key)
      };
    }
  }, {
    key: "canEdit",
    value: function canEdit(publicKey) {
      var _this$mod;
      // Host may force read-only (e.g. public Store view) without changing mod flags.
      if (this.editable === false) {
        return false;
      }
      if (!publicKey || !this.hasProfileModule() || !((_this$mod = this.mod) !== null && _this$mod !== void 0 && _this$mod.enable_profile_edits)) {
        return false;
      }
      return publicKey === this.mod.publicKey;
    }

    /**
     * Keychain holds another profile's private key — show help, not direct edit.
     */
  }, {
    key: "canEditHelp",
    value: function canEditHelp(publicKey) {
      var _this$mod2, _this$app$keychain3, _this$app$keychain3$r;
      if (this.editable === false) {
        return false;
      }
      if (!publicKey || !this.hasProfileModule() || !((_this$mod2 = this.mod) !== null && _this$mod2 !== void 0 && _this$mod2.enable_profile_edits)) {
        return false;
      }
      if (publicKey === this.mod.publicKey) {
        return false;
      }
      var localKey = (_this$app$keychain3 = this.app.keychain) === null || _this$app$keychain3 === void 0 || (_this$app$keychain3$r = _this$app$keychain3.returnKey) === null || _this$app$keychain3$r === void 0 ? void 0 : _this$app$keychain3$r.call(_this$app$keychain3, publicKey, true);
      return Boolean(localKey === null || localKey === void 0 ? void 0 : localKey.privateKey);
    }
  }, {
    key: "emptyDescriptionPlaceholderHtml",
    value: function emptyDescriptionPlaceholderHtml() {
      var _this$app$browser4;
      var canEdit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var text = canEdit ? DEFAULT_OWN_DESCRIPTION_PLACEHOLDER : DEFAULT_OTHER_DESCRIPTION_PLACEHOLDER;
      var safe = (_this$app$browser4 = this.app.browser) !== null && _this$app$browser4 !== void 0 && _this$app$browser4.sanitize ? this.app.browser.sanitize(text, true) : this.escapeText(text);
      return "<div class=\"saito-profile-description-placeholder\">".concat(safe, "</div>");
    }
  }, {
    key: "rootSelector",
    value: function rootSelector() {
      return this.ordinal ? "#saito-profile".concat(this.ordinal) : null;
    }
  }, {
    key: "queryRoot",
    value: function queryRoot() {
      var sel = this.rootSelector();
      return sel ? document.querySelector(sel) : null;
    }
  }, {
    key: "getFooterEl",
    value: function getFooterEl() {
      var _this$queryRoot;
      return ((_this$queryRoot = this.queryRoot()) === null || _this$queryRoot === void 0 ? void 0 : _this$queryRoot.querySelector('.saito-profile-footer')) || null;
    }
  }, {
    key: "getControlsEl",
    value: function getControlsEl() {
      var _this$queryRoot2;
      return ((_this$queryRoot2 = this.queryRoot()) === null || _this$queryRoot2 === void 0 ? void 0 : _this$queryRoot2.querySelector('.saito-profile-controls')) || null;
    }
  }, {
    key: "getMenuEl",
    value: function getMenuEl() {
      var _this$queryRoot3;
      return ((_this$queryRoot3 = this.queryRoot()) === null || _this$queryRoot3 === void 0 ? void 0 : _this$queryRoot3.querySelector('.saito-profile-menu')) || null;
    }
  }, {
    key: "remove",
    value: function remove() {
      var root = this.queryRoot();
      if (root) {
        root.remove();
      }
    }
  }, {
    key: "reset",
    value: function reset(publicKey) {
      var active_tab = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var tabs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      this.remove();
      if (!this.active_tab || !tabs.includes(this.active_tab)) {
        this.active_tab = active_tab;
      }
      this.resetMenuTabs(tabs);
      this.publicKey = publicKey;
      delete this.description;
      delete this.name;
      delete this.mask_key;
      delete this.banner;
      delete this.avatar;
      delete this.icon;
      this.ordinal = 0;
    }
  }, {
    key: "resetMenuTabs",
    value: function resetMenuTabs() {
      var tabs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      this.menu = {};
      var _iterator = _createForOfIteratorHelper(tabs),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var t = _step.value;
          this.menu[t] = [];
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    /**
     * @param {string} [container]
     * @param {string} [publicKey]
     */
  }, {
    key: "render",
    value: function render() {
      var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var publicKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      if (container) {
        this.container = container;
      }
      if (publicKey) {
        this.publicKey = publicKey;
      }
      if (!this.publicKey) {
        return;
      }
      if (this.ordinal == 0) {
        var max = 0;
        Array.from(document.querySelectorAll('.saito-profile')).forEach(function (ov) {
          var temp = parseInt(ov.id.replace('saito-profile', ''), 10);
          if (temp > max) {
            max = temp;
          }
        });
        this.ordinal = max + 1;
      }
      var myqs = "#saito-profile".concat(this.ordinal);
      var content = this.buildTemplateHtml();
      if (document.querySelector(myqs)) {
        this.app.browser.replaceElementBySelector(content, myqs);
      } else if (this.container) {
        this.app.browser.prependElementToSelector(content, this.container);
      } else {
        this.app.browser.addElementToDom(content);
      }
      if (this.hasProfileModule()) {
        this.app.connection.emit('profile-fetch-content-and-update-dom', this.publicKey);
      }
      this.renderMenuTabs();
      this.attachEvents();
    }
  }, {
    key: "buildTemplateHtml",
    value: function buildTemplateHtml() {
      var d = this.buildDisplayData(this.publicKey);
      var safeKey = this.escapeAttr(d.publicKey);
      var keyClass = this.classSafe(d.publicKey);
      var safeName = this.escapeText(d.name);
      var safeAvatar = this.escapeAttr(this.safeImgSrc(d.avatar, '/saito/img/dreamscape.png'));
      var bannerUrl = this.safeBannerUrl(d.banner);
      var bannerStyle = bannerUrl ? " style=\"background-image: url('".concat(this.escapeAttr(bannerUrl).replace(/'/g, '%27'), "')\"") : '';
      var canEdit = d.can_edit;
      var canEditHelp = d.can_edit_help;
      var bannerControl = '';
      if (canEditHelp) {
        bannerControl = "<i id=\"saito-profile-help\" class=\"saito-profile-banner-edit fa-regular fa-circle-question\" role=\"button\" tabindex=\"0\" aria-label=\"Profile editing help\"></i>";
      } else if (canEdit) {
        bannerControl = "<i class=\"saito-profile-banner-edit fas fa-camera\" role=\"button\" tabindex=\"0\" aria-label=\"Edit banner\"></i>";
      }
      var keyHtml = d.publicKey && !d.mask_key ? "\n      <div class=\"saito-profile-key-row\">\n        <span class=\"saito-profile-public-key\" title=\"".concat(safeKey, "\">").concat(safeKey, "</span>\n        <button\n          class=\"saito-profile-copy-key\"\n          type=\"button\"\n          data-profile-key=\"").concat(safeKey, "\"\n          aria-label=\"Copy address\"\n          title=\"Copy address\"\n        >\n          <i class=\"fas fa-copy\" aria-hidden=\"true\"></i>\n        </button>\n      </div>") : d.publicKey && d.mask_key ? '' : '';
      var hasBio = this.hasDescription(d.description);
      var descriptionClass = ['saito-profile-description', canEdit ? 'can-edit' : '', !hasBio ? 'empty' : ''].filter(Boolean).join(' ');
      var descriptionInner = '';
      if (hasBio) {
        var _this$app$browser5;
        var bioHtml = (_this$app$browser5 = this.app.browser) !== null && _this$app$browser5 !== void 0 && _this$app$browser5.sanitize ? this.app.browser.sanitize(d.description, true).replaceAll('\n', '<br>') : this.escapeText(d.description);
        descriptionInner = "\n        <div id=\"profile-description-".concat(safeKey, "\" class=\"profile-description-").concat(keyClass, "\" data-id=\"").concat(safeKey, "\">").concat(bioHtml, "</div>\n      ");
      } else if (canEdit) {
        descriptionInner = this.emptyDescriptionPlaceholderHtml(true);
      } else {
        // Non-editable + no host description: keep empty (hidden via CSS).
        descriptionInner = '';
      }
      var iconHtml = d.icon || '';
      return "\n      <div id=\"saito-profile".concat(this.ordinal, "\" class=\"saito-profile\" data-id=\"").concat(safeKey, "\">\n        <div class=\"saito-profile-card\" data-profile-key=\"").concat(safeKey, "\">\n          <div id=\"profile-banner-").concat(safeKey, "\" class=\"saito-profile-banner profile-banner-").concat(keyClass, " banner-").concat(keyClass, "\" data-id=\"").concat(safeKey, "\"").concat(bannerStyle, ">\n            ").concat(bannerControl, "\n          </div>\n          <div class=\"saito-profile-body\">\n            <div class=\"saito-profile-identity\">\n              <div class=\"saito-profile-avatar-wrap\">\n                <img class=\"saito-profile-avatar\" src=\"").concat(safeAvatar, "\" alt=\"").concat(this.escapeAttr(d.name), "\" />\n                ").concat(iconHtml, "\n              </div>\n              <div class=\"saito-profile-text\">\n                <span class=\"saito-profile-name\">").concat(safeName, "</span>\n                ").concat(keyHtml, "\n              </div>\n            </div>\n            <div class=\"").concat(descriptionClass, "\">").concat(descriptionInner, "</div>\n            <div class=\"saito-profile-controls saito-menu-select-subtle\"></div>\n            <div class=\"saito-profile-menu\"></div>\n            <div class=\"saito-profile-footer\"></div>\n          </div>\n        </div>\n      </div>\n    ");
    }
  }, {
    key: "renderMenuTabs",
    value: function renderMenuTabs() {
      var menu = this.getMenuEl();
      if (!menu) {
        this.renderTab();
        return;
      }
      menu.innerHTML = '';
      if (Object.keys(this.menu).length > 0) {
        for (var i in this.menu) {
          var class1 = i == this.active_tab ? ' active' : '';
          var class2 = this.menu[i].length > 0 ? '' : 'hidden';
          var html = "<div class=\"saito-profile-tab".concat(class1, "\" data-id=\"").concat(i, "\">\n                  ").concat(i, "\n                  <span class=\"").concat(class2, "\"> (").concat(this.menu[i].length, ")</span>\n                </div>");
          this.app.browser.addElementToSelector(html, "".concat(this.rootSelector(), " .saito-profile-menu"));
        }
      }
      this.renderTab();
    }
  }, {
    key: "renderTab",
    value: function renderTab() {
      if (!this.tab_container) {
        return;
      }
      var el = document.querySelector(this.tab_container);
      if (el) {
        el.innerHTML = '';
      }
      if (this.active_tab && this.menu[this.active_tab]) {
        var _iterator2 = _createForOfIteratorHelper(this.menu[this.active_tab]),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var p = _step2.value;
            p.render();
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    }
  }, {
    key: "ensureDomListener",
    value: function ensureDomListener() {
      var _this = this;
      if (this._dom_listener_bound) {
        return;
      }
      this._dom_listener_bound = true;
      this.app.connection.on('profile-update-dom', function (publicKey, data) {
        _this.applyProfileDomUpdate(publicKey, data);
      });
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this2 = this;
      this.ensureDomListener();
      var root = this.queryRoot();
      if (!root) {
        return;
      }
      if (this.tab_container) {
        root.querySelectorAll('.saito-profile-tab').forEach(function (el) {
          el.onclick = function (e) {
            if (_this2.active_tab != e.currentTarget.dataset.id) {
              _this2.active_tab = e.currentTarget.dataset.id;
              _this2.renderMenuTabs();
              _this2.attachEvents();
            }
          };
        });
      }
      root.querySelectorAll('.saito-profile-copy-key').forEach(function (btn) {
        btn.onclick = function (e) {
          var _navigator$clipboard;
          e.preventDefault();
          e.stopPropagation();
          var key = btn.getAttribute('data-profile-key') || _this2.publicKey || '';
          if (!key) {
            return;
          }
          var done = function done() {
            var _this2$app$browser;
            if (typeof siteMessage === 'function') {
              siteMessage('Address copied', 1200);
            } else if ((_this2$app$browser = _this2.app.browser) !== null && _this2$app$browser !== void 0 && _this2$app$browser.siteMessage) {
              _this2.app.browser.siteMessage('Address copied', 1200);
            }
          };
          if ((_navigator$clipboard = navigator.clipboard) !== null && _navigator$clipboard !== void 0 && _navigator$clipboard.writeText) {
            navigator.clipboard.writeText(key).then(done)["catch"](function () {});
          }
        };
      });
      var camera = root.querySelector('.saito-profile-banner-edit.fa-camera');
      if (camera && this.canEdit(this.publicKey)) {
        camera.onclick = function (e) {
          e.preventDefault();
          e.stopPropagation();
          _this2.app.connection.emit('profile-edit-banner', _this2.publicKey);
        };
      }
      var help = root.querySelector('#saito-profile-help');
      if (help) {
        help.onclick = function (e) {
          e.preventDefault();
          e.stopPropagation();
          var overlay = new SaitoOverlay(_this2.app, _this2.mod);
          var html = "<div class=\"saito-modal\">\n                <div class=\"saito-modal-title\">Profile Editing</div>\n                <div class=\"saito-profile-note\">You have the private key for this profile in your keychain.</div>\n                <div class=\"saito-profile-note\">You can edit it by importing that private key in a private browser\n                  directed to saito.io/profile</div>\n              </div>";
          overlay.show(html, function () {
            var localKey = _this2.app.keychain.returnKey(_this2.publicKey, true);
            if (localKey !== null && localKey !== void 0 && localKey.privateKey) {
              var obj = {
                publicKey: localKey.publicKey,
                privateKey: localKey.privateKey
              };
              var base64obj = _this2.app.crypto.stringToBase64(JSON.stringify(obj));
              var link = window.location.origin + '/profile?load_key=' + base64obj;
              navigator.clipboard.writeText(link);
              siteMessage('Private URL copied', 5000);
            }
          });
        };
      }
      var desc = root.querySelector('.saito-profile-description.can-edit');
      if (desc && this.canEdit(this.publicKey)) {
        desc.onclick = function (e) {
          e.preventDefault();
          _this2.app.connection.emit('profile-edit-description', _this2.publicKey);
        };
      }
      root.querySelectorAll('.saito-profile-banner-edit, .saito-profile-copy-key').forEach(function (item) {
        item.onkeydown = function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            item.click();
          }
        };
      });
    }
  }, {
    key: "applyProfileDomUpdate",
    value: function applyProfileDomUpdate(publicKey, data) {
      var _this3 = this;
      if (!publicKey || !data || !this.hasProfileModule()) {
        return;
      }
      if (this.publicKey && publicKey !== this.publicKey) {
        return;
      }
      var root = this.queryRoot();
      if (!root) {
        return;
      }
      var banner = data.banner,
        description = data.description,
        image = data.image;
      var keyClass = this.classSafe(publicKey);
      root.querySelectorAll(".banner-".concat(keyClass, ", .profile-banner-").concat(keyClass)).forEach(function (el) {
        el.style.backgroundImage = banner ? "url('".concat(banner, "')") : '';
      });
      var container = root.querySelector('.saito-profile-description');
      if (container) {
        var canEdit = this.canEdit(publicKey);
        container.classList.toggle('can-edit', canEdit);
        container.classList.toggle('empty', !this.hasDescription(description));
        if (!this.hasDescription(description)) {
          container.innerHTML = canEdit ? this.emptyDescriptionPlaceholderHtml(true) : '';
        } else {
          var sanitized = this.app.browser.sanitize(description, true).replaceAll('\n', '<br>');
          container.innerHTML = "\n            <div id=\"profile-description-".concat(publicKey, "\" class=\"profile-description-").concat(keyClass, "\" data-id=\"").concat(publicKey, "\">\n              ").concat(sanitized, "\n            </div>\n          ");
        }
        if (canEdit) {
          container.onclick = function (e) {
            e.preventDefault();
            _this3.app.connection.emit('profile-edit-description', publicKey);
          };
        } else {
          container.onclick = null;
        }
      }
      var avatarNodes = root.querySelectorAll('.saito-profile-avatar');
      if (image) {
        avatarNodes.forEach(function (el) {
          el.src = image;
        });
      } else if (!this.avatar) {
        var fallback = this.app.keychain.returnIdenticon(publicKey) || '/saito/img/dreamscape.png';
        avatarNodes.forEach(function (el) {
          el.src = fallback;
        });
      }
    }
  }]);
}();
module.exports = SaitoProfile;